
import React, { HTMLAttributes } from 'react'
import cn from 'clsx'
import styled from 'styled-components'
import { BodyTextLarge, BodyTextMedium, BodyTextSmall } from '../../Luxkit/Typography/BodyText'
import { CaptionLarge, CaptionMedium } from '../../Luxkit/Typography/Caption'
import LoadingBox from './LoadingBox'
import { Heading1Style, Heading2Style, Heading3Style, Heading4Style, Heading5Style, Heading6Style } from '../../Luxkit/Typography/Heading'
import { Subtitle1Style, Subtitle2Style, Subtitle3Style } from 'components/Luxkit/Typography/Subtitle'
import { fillArray } from 'lib/arrayUtils'

type typographySizes = 'body-small' |
 'body-medium' |
 'body-large' |
 'caption-small' |
 'caption-large' |
 'heading-one' |
 'heading-two' |
 'heading-three' |
 'heading-four' |
 'heading-five' |
 'heading-six' |
 'subtitle-one' |
 'subtitle-two' |
 'subtitle-three'

const Box = styled(LoadingBox)`
  display: inline-block;
  width: 100%;
  height: 1em;
  border-radius: ${props => props.theme.borderRadius.medium};
`

const LoadingContainer = styled.div`
  width: 100%;
  display: inline-block;

  &.size-body-large {
    ${BodyTextLarge}
  }

  &.size-body-medium {
    ${BodyTextMedium}
  }

  &.size-body-small {
    ${BodyTextSmall}
  }

  &.size-caption-large {
    ${CaptionLarge}
  }

  &.size-caption-small {
    ${CaptionMedium}
  }

  &.size-heading-one {
    ${Heading1Style}
  }

  &.size-heading-two {
    ${Heading2Style}
  }

  &.size-heading-three {
    ${Heading3Style}
  }

  &.size-heading-four {
    ${Heading4Style}
  }

  &.size-heading-five {
    ${Heading5Style}
  }

  &.size-heading-six {
    ${Heading6Style}
  }

  &.size-subtitle-one {
    ${Subtitle1Style}
  }

  &.size-subtitle-two {
    ${Subtitle2Style}
  }

  &.size-subtitle-three {
    ${Subtitle3Style}
  }
`

interface Props extends HTMLAttributes<HTMLDivElement> {
  size: typographySizes | 'inherit';
  lines?: number;
}

function TextLoadingBox(props: Props) {
  const { size, className, lines = 1, ...rest } = props
  return <LoadingContainer {...rest} className={cn(className, `size-${size}`)}>
    {fillArray(lines).map((value) => <Box key={value} />)}
  </LoadingContainer>
}

export default TextLoadingBox
